/**
 * Adds the ES5 Function.prototype.bind() function to the namespace
 *
 * Documentation: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
 * Compatibility IE9+: http://caniuse.com/#feat=es5
 *
 */
if (!Function.prototype.bind) {
    Function.prototype.bind = function(oThis) {
        if (typeof this !== 'function') {
            // closest thing possible to the ECMAScript 5
            // internal IsCallable function
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }

        var aArgs   = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP    = function() {},
            fBound  = function() {
              return fToBind.apply(this instanceof fNOP ? this : oThis,
                     aArgs.concat(Array.prototype.slice.call(arguments)));
            };

        if (this.prototype) {
            // native functions don't have a prototype
            fNOP.prototype = this.prototype;
        }

        fBound.prototype = new fNOP();

        return fBound;
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/js/_polyfills/Function.prototype.bind.js
// module id = 1
// module chunks = 1